// Custom Query
$(document).ready(function() {

    console.log("Welcome to Providence RI's website!")
    // had to add timeout for the outerHeight to calc properly
    setTimeout(function(){
    if ( $('.fig-banner').length ) {
        var bannerHeight = $('.fig-banner').outerHeight(true);
        $('footer').css({"padding-bottom": bannerHeight + "px"});

        $(window).resize(function() {
            var bannerHeight = $('.fig-banner').outerHeight(true);
            $('footer').css({"padding-bottom": bannerHeight + "px"});
        });
    }
}, 1);

});

$('header .icon-search').click(function() {
    $('header .search-form').toggleClass('searchable');
});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/headerBanner.js